<template>
    <div>
        <Row :gutter="16" style="margin-bottom: 24px">
            <Col span="6">
            <Input v-model="query.keyword" placeholder="请输入姓名、手机号进行搜索" />
            </Col>
            <Col span="6">
            <Select v-model="query.auth_type" placeholder="认证方式" clearable style="width: 100%">
                <Option v-for="item in authOptions" :key="item.value" :value="item.value">{{ item.label }}</Option>
            </Select>
            </Col>
            <Col span="6">
            <Button type="primary" icon="ios-search" @click="search">搜索</Button>
            </Col>
        </Row>
        <Table border :loading="loading" :columns="columns" :data="tableData">
            <template slot-scope="{ row }" slot="authMethod">
                <span>{{ authMethodName(row.auth_method) }}</span>
            </template>
            <template slot-scope="{ row }" slot="action">
                <Button type="success" size="small" @click="handleUnbind(row)">解绑认证</Button>
            </template>
        </Table>
        <br />
        <Page :total="total" :current="query.page" :page-size="query.limit" style="text-align:right" show-elevator
            show-total @on-change="pageChange" />
    </div>
</template>

<script>
import { fetchPersonalUsers, unbindPersonalUser } from '@/api/userManage'

export default {
    data() {
        return {
            loading: false,
            query: {
                keyword: '',
                auth_type: '',
                page: 1,
                limit: 20
            },
            total: 0,
            authOptions: [
                { label: '全部', value: '' },
                { label: '运营商三要素', value: 1 },
                { label: '人脸认证', value: 2 }
            ],
            columns: [
                { title: '序号', type: 'index', width: 80, align: 'center' },
                { title: '姓名', key: 'name', align: 'center' },
                { title: '手机号', key: 'phone', align: 'center' },
                { title: '身份证号', key: 'id_card', align: 'center' },
                { title: '认证方式', key: 'auth_type', align: 'center' },
                { title: '认证时间', key: 'auth_time', align: 'center' },
                { title: '操作', slot: 'action', align: 'center', width: 140 }
            ],
            tableData: []
        }
    },
    created() {
        this.fetchList()
    },
    methods: {
        authMethodName(value) {
            const current = this.authOptions.find(item => item.value === value)
            return current ? current.label : value || '-'
        },
        pageChange(page) {
            this.query.page = page
            this.fetchList()
        },
        search() {
            this.query.page = 1
            this.fetchList()
        },
        fetchList() {
            this.loading = true
            fetchPersonalUsers(this.query).then(res => {
                const pageData = (res.data && res.data.data) || {}
                const list = pageData.data || []
                this.tableData = this.decorateList(list)
                this.total = pageData.total || list.length
                if (pageData.current_page) {
                    this.query.page = pageData.current_page
                }
            }).catch(err => {
                this.$Message.warning(err && err.msg ? err.msg : '获取个人用户失败，展示示例数据')
                this.useMock()
            }).finally(() => {
                this.loading = false
            })
        },
        decorateList(list) {
            return list.map(item => ({
                id: item.id || '',
                name: item.real_name || item.name || '姓名',
                phone: item.phone || '',
                id_card: item.id_card || '',
                // auth_type: 1 运营商认证；2 人脸认证
                auth_type: item.auth_type,
                auth_time: item.created_at || ''
            }))
        },
        useMock() {
            this.tableData = [
                { id: 1, name: '姓名1', phone: '12345678912', id_card: '236547891236584596', auth_method: 'carrier', auth_time: '2022-05-06' },
                { id: 2, name: '姓名2', phone: '12345678912', id_card: '236547891236584596', auth_method: 'face', auth_time: '2022-05-06' },
                { id: 3, name: '姓名3', phone: '12345678912', id_card: '236547891236584596', auth_method: 'face', auth_time: '2022-05-06' }
            ]
            this.total = this.tableData.length
        },
        handleUnbind(row) {
            this.$Modal.confirm({
                title: '提示',
                content: `是否确认解绑${row.name}的认证？`,
                onOk: () => {
                    return unbindPersonalUser({ id: row.id }).then(res => {
                        this.$Message.success((res && res.msg) || '解绑成功')
                        this.fetchList()
                    }).catch(err => {
                        this.$Message.warning(err && err.msg ? err.msg : '解绑失败')
                        this.fetchList()
                    })
                }
            })
        }
    }
}
</script>
